export enum EnumListType {
  ol1, // decimal
  ol2, // ckj-decimal
  ol3, // upper-decimal
  ul1, // circle
  ul2, // ring
  ul3, // arrow
}
